import API from "..";
import {
  API_POST_DEPARTMENT_MASTER_IMPORT
} from "../../constants/api";

async function importDepartments(data) {
  const headers = {
    "Content-Type": "multipart/form-data",
  };

  try {
    const response = await API.post(API_POST_DEPARTMENT_MASTER_IMPORT, data, {
      headers,
    });
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

export { importDepartments };
